document
  .getElementById("scroll-top")
  .addEventListener("click", this.onScrollTop);

const scrollTopEl = document.getElementById("scroll-top");
let scrollingAmount = 0;
let scrollTick = false;
document.addEventListener("scroll", (ev) => {
  scrollingAmount = window.scrollY;
  if (scrollTick) return;
  scrollTick = true;
  window.requestAnimationFrame(() => {
    if (scrollingAmount > 30) {
      scrollTopEl.classList.add("visible");
    } else {
      scrollTopEl.classList.remove("visible");
    }
    scrollTick = false;
  });
});

function onScrollTop() {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}
